export default "__VITE_ASSET__CKK4MuyK__"